// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"742":"d3703990","787":"4e26e54a"}[chunkId] + ".chunk.js";
};